import { mergeStyles } from '../../../../internal/utils/mergeStyles';
import mainStyles from './styles.module.css';
import { getThemeStyles } from './theme';
import { getSizeStyles } from './size';
import { memoizeWith } from 'ramda';
function getCustomTooltipStyles(theme, size) {
  var themeStyles = getThemeStyles(theme);
  var sizeStyles = getSizeStyles(size);
  return mergeStyles(mainStyles, themeStyles, sizeStyles);
}
function getCustomTooltipStylesIdentity(theme, size) {
  return "".concat(theme).concat(size);
}
export var getStyles = memoizeWith(getCustomTooltipStylesIdentity, getCustomTooltipStyles);